import templateUrl from './scan-history.html'
import './scan-history.scss'

class ScanHistoryController {
  constructor (ProjectWebscannerService, SegmentAnalytics) {
    'ngInject'

    this.ProjectWebscannerService = ProjectWebscannerService
    this.SegmentAnalytics = SegmentAnalytics
    this.scans = []
    this.isLoading = false
    this.error = null
  }

  $onInit () {
    this.loadScans()
  }

  loadScans () {
    this.isLoading = true
    this.error = null
    this.ProjectWebscannerService.fetchScans(this.projectId)
      .then(scans => {
        this.scans = scans
          .sort((a, b) => new Date(b.dateStart) - new Date(a.dateStart))
          .map(scan => ({
            ...scan,
            duration: this.calcDuration(scan)
          }))
      })
      .catch(err => {
        this.error = err.data?.message || 'Failed to load scan history.'
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  calcDuration (scan) {
    if (!scan.dateEnd || !scan.dateStart) return 'N/A'
    const durationMs = new Date(scan.dateEnd) - new Date(scan.dateStart)
    const minutes = Math.floor(durationMs / 60000)
    const seconds = Math.floor((durationMs % 60000) / 1000)
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }

  statusLabel (status) {
    return this.ProjectWebscannerService.statusLabel(status)
  }

  triggerLabel (trigger) {
    return this.ProjectWebscannerService.triggerLabel(trigger)
  }

  statusClass (status) {
    return this.ProjectWebscannerService.statusClass(status)
  }

  performanceSummary (scan) {
    return this.ProjectWebscannerService.performanceSummary(scan)
  }

  trackReportViewed (scan) {
    this.SegmentAnalytics.trackEvent('webscanner report viewed', {
      source: 'history_modal',
      projectId: this.projectId,
      scanId: scan?.id,
      url: scan?.url
    })
  }
}

export const ScanHistoryComponent = {
  bindings: {
    projectId: '<'
  },
  require: {
    modalCtrl: '^^cdblModal'
  },
  controller: ScanHistoryController,
  templateUrl
}
